<template>
  <div
    id="term"
    class="menucontent"
    v-if="showModal"
    style="overflow-y: auto; max-height: 100%"
  >
    <div class="inmenucontent animate__animated animate__bounceIn" :style="{ backgroundImage: createBackgroundString }">
      <button class="hidemenu" @click="hide">
        <i class="fas fa-times"></i>
      </button>
      <div class="ininmnct px-3">
        <div class="menuhead mb-3">
          <i class="fas fa-code"></i> ข้อตกลงในการใช้งาน
        </div>
        <div class="-inner-wrapper">
          <ul class="list-unstyled -detail" style="font-size: 14px">
            <li>
              -สมาชิกต้องกรอกข้อมูลจริงให้สมบูรณ์และสามารถติดต่อได้
              เพื่อเปิดบัญชี (บริษัทจำกัดคนละบัญชีเท่านั้น)
            </li>
            <li>
              -ชื่อ-นามสกุล กับ ชื่อในข้อมูลธนาคารที่ให้สำหรับการฝาก/ถอน
              ต้องตรงกัน
              (บริษัทอนุมัติเฉพาะรายการที่ข้อมูลตรงกับข้อมูลสมาชิกเท่านั้น
              หากมีข้อผิดพลาดจากสมาชิกบริษัทจะไม่รับผิดชอบใดๆ)
            </li>
            <li>
              -ทุกข้อเสนอจำกัดสำหรับหนึ่ง บุคคล, ชื่อ หรือ สกุล , ที่อยุ่ ,
              อีเมล์ , เบอร์โทรศัพท์, บัญชีธนาคาร , IP แอดเดรส เดียวเท่านั้น
              (บริษัทมีระบบตรวจสอบ การใช้ข้อมูล การเข้าใช้ ที่ซ้ำซ้อนกัน)
            </li>
            <li>
              -สมาชิกที่ต้องการเปลี่ยนแปลงข้อมูล จะต้องไม่ติดกิจกรรมใดๆ
              และเคยฝากเงินแล้วเท่านั้น
            </li>
            <li>
              -สมาชิกต้องวางเดิมพัน จึงจะสามารถถอนเงินได้ ( ไม่สามารถฝาก
              และถอนเงินทันทีโดยที่ไม่วางเดิมพัน )
            </li>
            <li>
              -ข้อกำหนดการวางเดิมพัน เกมส์สล็อตเดิมพันครั้งละไม่เกิน 500 บาท
              ซื้อฟีเจอร์ได้ไม่เกิน 3000 บาท เกมส์คาสิโน ไม่เกินครั้งละ 3000 บาท
            </li>
            <li>
              -ในกรณีตรวจพบว่าสมาชิก ฝาก/ถอน ผิดปกติเพื่อก่อกวน เอาเปรียบบริษัท
              หรือคาดว่าเป็นมิจฉาชีพ ทีมงานขอสงวนสิทธิ์ในการระงับยูสเซอร์ตรวจสอบ
              และตัดสิน
            </li>
            <li>
              -ในกรณีตรวจพบว่าท่านสมาชิกมีการละเมิดข้อกำหนดเงื่อนไข
              หรือมีการกระทำผิดกติกาในการเข้าร่วมโปรโมชั่นเพื่อให้ได้มาซึ่งเครดิต,
              โบนัสพิเศษ, เทิร์นโอเวอร์ ในทางทุจจริต
              ทางเราขอสงวนสิทธิ์ในการระงับใช้บัญชีนั้นๆ ทันที
              และเครดิตที่ได้มาไม่สามารถถอนได้
            </li>
            <li>
              -บริษัทขอสงวนสิทธิ์ในการแก้ไขหรือ ยกเลิกโปรโมชั่นสำหรับท่านสมาชิก
              ได้โดยอัพเดทหน้าเว็บไซต์ และไม่ต้องแจ้งให้ทราบล่วงหน้า
            </li>
            <li>
              -บริษัทขอสงวนสิทธิ์โดยใช้ดุลยพินิจแต่เพียงผู้เดียวในการทำให้เงินรางวัลเป็นโมฆะและริบยอดเงินใดก็ตามในบัญชีการเดิมพันของคุณ
              ในการสิ้นสุดข้อตกลงและ/หรือระงับการให้บริการ/ปิดการใช้งานบัญชี
            </li>
            <li>-หากเราระบุได้ว่าคุณมีบัญชีกับเรามากกว่าหนึ่งบัญชี</li>
            <li>-หากคุณกำลังละเมิดข้อกำหนดใดๆ ของข้อตกลงนี้</li>
            <li>
              -หาก
              บริษัททราบว่าคุณได้วางเดิมพันกับเว็บไซต์วางเดิมพันออนไลน์หรือใช้บริการใดก็ตามและถูกสงสัยว่าได้ฉ้อโกง
              สมรู้ร่วมคิด หรือกิจกรรมที่ไม่เหมาะสมหรือมิชอบด้วยกฎหมาย
            </li>
            <li>
              -หากบริษัท ไม่สามารถทำการตรวจสอบ
              หรือข้อมูลที่ท่านให้มานั้นไม่ถูกต้อง, ข้อมูลเท็จ
              หรือข้อมูลไม่สมบูรณ์
              ทางเราขอสงวนสิทธิ์ที่จะทำการปฏิเสธโดยไม่มีการแจ้งให้ทราบล่วงหน้า
              หรือไม่รับผิดชอบใดๆในบัญชีของท่าน
            </li>
            <li>
              -หาก
              คุณฝากเงินด้วยเงินที่ได้มาด้วยการทุจริตหรือมิชอบด้วยกฎหมายหรือได้มาอย่างไม่ถูกต้อง
            </li>
            <li>
              -หากบริษัท
              สงสัยว่าบัญชีของท่านมีความเกี่ยวข้องกับการฉ้อโกงหรือการกระทำที่เป็นทุจริต
            </li>
            <li>
              -หากบริษัท สงสัยว่าท่าน หรือสมรู้ร่วมคิดกับบุคคลอื่นๆ
              เพื่อที่จะทำการอย่างใดอย่างหนึ่ง หรือพยายามฉ้อโกงทางเว็บ
            </li>
            <li>
              -หากบริษัท ได้รับแจ้งว่าท่านได้มีการปลอม หรือแทรกแซง
              หรือดำเนินการขั้นตอนเพื่อทำการปกปิดหรือแทรกแซงในทางใด ๆ
              ในเรื่องของ IP ในอุปกรณ์ที่ใช้ในการเข้าถึงเว็บไซต์ เช่น Virtual
              Private Network "VPN"
            </li>
            <li>
              -ลูกค้าสามารถดำเนินการถอนเงินได้ 15 เท่าจากยอดฝาก และสูงสุดไม่เกิน
              300,000บาท เท่านั้น
            </li>
            <li>
              -คุณจำเป็นต้องเล่นอย่างน้อย 100
              เปอร์เซนต์ของจำนวนเงินที่คุณฝากเข้ามาแต่ละครั้ง
              ก่อนที่คุณจะทำการทำเรื่องขอถอนเงินได้
              ถ้ารายการวางเดิมพันไม่ได้รับการยอมรับ หรือแข่งไม่จบ หรือ
              กรณีที่คุณวางเดิมพันแต่ผลการแข่งขันออกมาเสมอกัน
              หรือวางเดิมพันในคู่ที่ราคาเสมอ
              จะไม่สามารถนำมาใช้ในการคำนวณยอดเทริ์นโอเวอร์ได้
              และถ้าจำนวนเงินในการเล่นเข้ามาไม่ถึงเกณฑ์ แต่คุณต้องการขอถอนเงิน
              คุณจะเสียค่าดำเนินการจำนวน 20 เปอร์เซนต์ของจำนวนเงินที่คุณจะถอน
            </li>
          </ul>
          <b
            >**บริษัท autoinfinity.co
            เป็นผู้ตัดสินเพียงผู้เดียวและคำตัดสินใจถือเป็นที่สิ้นสุด**</b
          >
        </div>
      </div>
    </div>
    <div class="overlaymenu"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "termmodal-component",
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
  },
  computed: {
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(140deg, ${this.WebSetting.color1}, #000000 95%), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
  }
};
</script>

<style scoped>
.-icon {
  color: white;
}
</style>
